module.exports = __webpack_public_path__ + "static/media/futura-pt-cond-book.998e6bae.ttf";